import { Component, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { Bills } from 'src/app/model/stripe-models/subscription/bills';
import { HeaderServiceService } from 'src/app/services/header-service/header-service.service';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { StripeService } from 'src/app/services/stripe-service/stripe.service';
import { UserService } from 'src/app/services/user-service/userservice';

@Component({
    selector: 'app-rechnungen',
    templateUrl: './rechnungen.component.html',
    styleUrls: ['./rechnungen.component.scss'],
    standalone: false
})
export class RechnungenComponent implements OnInit {

  totalNumberOfElements: number;
  pageIndex = 0;
  pageSize = 5;
  bills: Bills;
  activeOrg;
  loading: boolean = false;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  constructor(private cdr: ChangeDetectorRef,
    private stripeService: StripeService,
    private userService: UserService,
    public headerService: HeaderServiceService) { }

  ngOnInit(): void {
    this.loading = true;
    this.activeOrg = this.headerService.activeOrganisation.organisationId;
    this.getBillingDataSize(this.activeOrg.toString());
    this.getBillingData(this.activeOrg.toString(), '', this.pageSize.toString());

  }

  isUserAdminOfOrganisationOrPlattformAdmin() {
    return this.userService.isUserAdminOfOrganisationOrPlattformAdmin(
      this.activeOrg
    );
  }

  onPageChange(pageChangeEvent: PageEvent) {
    this.loading = true;
    this.cdr.detectChanges();
    const previousIndex = this.pageIndex;
    const previousPageSize = this.pageSize;
    this.pageIndex = pageChangeEvent.pageIndex;
    this.pageSize = pageChangeEvent.pageSize;
    let paginationDirectionBill: string;
    if (this.bills && this.bills.bills && this.bills.bills.length > 0) {
      if (this.pageSize != previousPageSize) {
        paginationDirectionBill = '';
        this.pageIndex = 0;
      }
      else if (this.pageIndex > previousIndex) {
        paginationDirectionBill = '&starting_after=' + this.bills.bills[this.bills.bills.length - 1].id;
      }
      else if (this.pageIndex < previousIndex) {
        paginationDirectionBill = '&ending_before=' + this.bills.bills[0].id;
      }
    }
    this.getBillingData(this.activeOrg, paginationDirectionBill, this.pageSize.toString());
    this.cdr.detectChanges();
  }

  getBillingData(activeOrg: string, paginationDirectionBill: string, limit: string) {
    this.stripeService.getBillingData(activeOrg, paginationDirectionBill, limit)
      .pipe(catchError(error => { return of([]); }))
      .subscribe((data: Bills) => {
        if (data) {
          this.bills = data;
          this.loading = false;
          this.cdr.detectChanges();
        }
        else {
          this.loading = false;
          this.cdr.detectChanges();
        }

      });
  }

  getBillingDataSize(activeOrg: string) {
    this.stripeService.getBillingDataSize(activeOrg)
      .pipe(catchError(error => { return of("0"); }))
      .subscribe(data => {
        if (typeof data === 'string') { this.totalNumberOfElements = Number(data); }
        else { this.totalNumberOfElements = 0; }
        this.cdr.detectChanges();
      });
  }
}
